export enum Period {
  Month = 'MONTH',
  Month3 = 'MONTH_3',
  Month6 = 'MONTH_6',
  StartYear = 'START_YEAR',
  Year = 'YEAR',
  AllHistory = 'ALL_HISTORY',
}

export const availablePeriods = [
  Period.Month,
  Period.Month3,
  Period.Month6,
  Period.StartYear,
  Period.Year,
  Period.AllHistory,
];
